/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import styles from './styles.scss';

export class NoInternet extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 146 100"
          xmlSpace="preserve"
        >
        <g id="tx8owZ_1_">
          <g>
            <path className={styles.st0}
              d="M144.3,32.1c-4.6,4.6-9.1,9.1-13.7,13.7c-1.6,1.7-2.3,1.7-4,0.1c-9.9-9.7-21.6-16.2-35.1-19.6
              C79.3,23.1,66.9,23,54.5,26C44.2,28.4,34.8,32.7,26.3,39c-2.8,2.1-5.4,4.5-8.1,6.9c-1.6,1.4-2.2,1.4-3.7-0.1
              c-4.3-4.3-8.6-8.6-12.9-13c-0.3-0.3-0.5-0.5-0.8-0.8c0-0.4,0-0.8,0-1.1c2.6-2.4,5.1-5,7.9-7.3c7.6-6.3,16.1-11.3,25.2-15.1
              c8.8-3.6,17.9-6,27.4-7c2-0.2,4-0.5,6-0.7c3.4,0,6.9,0,10.3,0c0.3,0.1,0.6,0.2,0.9,0.2c8.6,0.6,17,2.1,25.3,4.8
              c6.3,2,12.3,4.7,18.1,7.9c5.7,3.2,11,6.9,15.9,11.1c2.2,1.9,4.4,4,6.5,6.1C144.3,31.3,144.3,31.7,144.3,32.1z"
            />
            <path className={styles.st0}
              d="M72.3,97.9c-2.8-2.8-5.5-5.6-8.3-8.3c-3.5-3.5-7.1-6.9-10.6-10.4c-1.1-1.1-1.1-1.5,0-2.5
              c3.7-3.4,7.9-6.1,12.9-7.3c5.6-1.4,11-0.9,16.2,1.3c3.5,1.4,6.5,3.6,9.2,6c1,0.9,1.1,1.3,0.2,2.3c-2.5,2.5-5,5-7.6,7.5
              c-3.8,3.7-7.6,7.3-11.4,10.9c-0.2,0.2-0.3,0.3-0.4,0.5C72.4,97.9,72.3,97.9,72.3,97.9z"
            />
            <path className={styles.st0}
              d="M120.7,55c-0.3,0.5-0.5,1-0.8,1.4c-4.4,4.4-8.7,8.7-13.1,13.1c-1,1-1.8,1-2.9,0c-6.4-6.1-13.8-10.1-22.4-11.9
              c-8.5-1.7-16.8-1-24.9,2c-5.9,2.2-11.1,5.6-15.6,10c-1,0.9-1.8,0.9-2.8,0c-4.4-4.4-8.7-8.7-13.1-13.1c-0.9-0.9-0.9-1.8,0-2.7
              c8.8-8.7,19.2-14.5,31.2-17.5c10.4-2.6,21-2.6,31.5-0.2c10.3,2.4,19.6,6.9,27.7,13.7c1.5,1.3,3,2.7,4.5,4
              C120.3,54.1,120.4,54.6,120.7,55z"
            />
          </g>
        </g>
        <g>
          <defs>
            <circle id="SVGID_1_" cx="72.5" cy="46" r="26" />
          </defs>
          <clipPath id="SVGID_2_">
            <use xlinkHref="#SVGID_1_" />
          </clipPath>
          <g className={styles.st1}>
            <defs>
              <rect id="SVGID_3_" x="35.7" y="9.2" width="73.6" height="73.6" />
            </defs>
            <clipPath id="SVGID_4_">
              <use xlinkHref="#SVGID_3_" />
            </clipPath>
            <rect x="44" y="17.5" className={styles.st2} width="56.9" height="56.9" />
          </g>
        </g>
        <g>
          <defs>
            <path id="SVGID_5_"
              d="M68.6,56.3h7.4c0.5,0,1,0.4,1,1v7.4c0,0.5-0.4,1-1,1h-7.4c-0.5,0-1-0.4-1-1v-7.4
              C67.6,56.7,68,56.3,68.6,56.3z"
            />
          </defs>
          <clipPath id="SVGID_6_">
            <use xlinkHref="#SVGID_5_" />
          </clipPath>
          <g className={styles.st3}>
            <defs>
              <rect id="SVGID_7_" x="35.2" y="9.2" width="73.6" height="73.6" />
            </defs>
            <clipPath id="SVGID_8_">
              <use xlinkHref="#SVGID_7_" />
            </clipPath>
            <rect x="65.1" y="53.8" className={styles.st4} width="14.2" height="14.2" />
          </g>
        </g>
        <g>
          <defs>
            <path id="SVGID_9_"
              d="M68.1,27.8h8.3c0.5,0,1,0.4,1,1c0,0,0,0,0,0l-0.5,23.1c0,0.5-0.4,1-1,1h-7.4c-0.5,0-1-0.4-1-1l-0.5-23.1
              C67.1,28.3,67.5,27.9,68.1,27.8C68.1,27.8,68.1,27.8,68.1,27.8z"
            />
          </defs>
          <clipPath id="SVGID_10_">
            <use xlinkHref="#SVGID_9_" />
          </clipPath>
          <g className={styles.st5}>
            <defs>
              <rect id="SVGID_11_" x="35.2" y="9.2" width="73.6" height="73.6" />
            </defs>
            <clipPath id="SVGID_12_">
              <use xlinkHref="#SVGID_11_" />
            </clipPath>
            <rect x="64.7" y="25.4" className={styles.st6} width="15.2" height="29.9" />
          </g>
        </g>
        </svg>
      </div>
    );
  }
}

NoInternet.propTypes = {
  className: PropTypes.string,
};

export default NoInternet;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/noInternet/index.jsx